/**
 * 회원 탈퇴 — 계정 메뉴의 '회원 탈퇴'를 누르면 확인 창을 띄우고, 확인하면 지운다.
 *
 * 되돌릴 수 없는 일이라 두 단계로 나눈다. 확인 창은 서버가 함께 내려보내므로
 * (inc/auth.php) 여기서는 여닫기와 요청만 맡는다 — <dialog> 라서 초점 가두기와
 * Esc 닫기는 브라우저가 한다.
 *
 * 실패하면 창을 닫지 않고 그 안에 이유를 적는다. 창이 닫혀 버리면 무엇이 잘못됐는지
 * 알 수 없는 채로 다시 누르게 된다.
 */
const InitAccountWithdraw = () => {
  const dialog = document.querySelector('[data-academy-withdraw-dialog]');
  const trigger = document.querySelector('[data-academy-withdraw]');
  const config = window.qrshopAcademy;

  if (!dialog || !trigger || typeof dialog.showModal !== 'function') {
    return;
  }

  const error = dialog.querySelector('[data-academy-withdraw-error]');
  const confirm = dialog.querySelector('[data-academy-withdraw-confirm]');
  const cancel = dialog.querySelector('[data-academy-withdraw-cancel]');

  const setError = (message) => {
    if (!error) {
      return;
    }

    error.textContent = message || '';
    error.hidden = !message;
  };

  trigger.addEventListener('click', () => {
    setError('');
    dialog.showModal();
  });

  cancel?.addEventListener('click', () => dialog.close());

  // 바깥(백드롭)을 눌러도 닫는다 — 안쪽 상자를 누른 경우는 제외한다.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  confirm?.addEventListener('click', async () => {
    if (!config?.restUrl || !config?.nonce) {
      setError('잠시 뒤 다시 시도해 주세요.');
      return;
    }

    confirm.disabled = true;
    setError('');

    try {
      const response = await fetch(`${config.restUrl}/account/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': config.nonce },
      });
      const data = await response.json();

      if (!response.ok || !data?.success) {
        throw new Error(data?.message || '탈퇴 처리에 실패했습니다.');
      }

      // 계정이 사라졌으므로 지금 화면의 로그인 상태도 의미가 없다 — 처음 화면으로 보낸다.
      location.assign(data.redirect || '/');
      return;
    } catch (requestError) {
      setError(requestError.message);
    }

    confirm.disabled = false;
  });
};

export default InitAccountWithdraw;
